(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["quote-workspace-prototype"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('quote-workspace-form')) {
    class QuoteWorkspaceForm extends HTMLElement {
      connectedCallback() {
        this.frame = this.querySelector('[data-quote-workspace-frame]');
        this.loading = this.querySelector('[data-quote-workspace-loading]');

        if (!this.frame) {
          return;
        }

        this.handleMessage = this.handleMessage.bind(this);
        this.handleLoad = this.handleLoad.bind(this);
        window.addEventListener('message', this.handleMessage);
        this.frame.addEventListener('load', this.handleLoad);
      }

      disconnectedCallback() {
        window.removeEventListener('message', this.handleMessage);
        this.frame?.removeEventListener('load', this.handleLoad);
        window.clearTimeout(this.loadingFallback);
      }

      handleLoad() {
        window.clearTimeout(this.loadingFallback);
        this.loadingFallback = window.setTimeout(() => {
          const isFirstReady = this.dataset.loaded !== 'true';
          this.markReady();

          if (isFirstReady) {
            this.scrollToStart('auto');
          }
        }, 250);
      }

      handleMessage(event) {
        if (
          !this.frame ||
          !this.isTrustedGoogleOrigin(event.origin)
        ) {
          return;
        }

        const message = event.data;

        if (!message || message.source !== 'debreuck-google-workspace-prototype') {
          return;
        }

        if (message.type === 'resize') {
          const height = Number(message.detail?.height);

          if (Number.isFinite(height) && height >= 300 && height <= 8000) {
            const isFirstReady = this.dataset.loaded !== 'true';
            this.frame.style.height = `${height}px`;
            this.markReady();

            if (isFirstReady) {
              this.scrollToStart('auto');
            }
          }
        }

        if (message.type === 'step-change') {
          this.scrollToStart('smooth');
        }

        if (message.type === 'success') {
          this.dataset.submissionState = 'success';
          this.markReady();
          this.scrollToStart('smooth');
        }

        if (message.type === 'error') {
          this.dataset.submissionState = 'error';
          this.markReady();
        }
      }

      markReady() {
        window.clearTimeout(this.loadingFallback);
        this.dataset.loaded = 'true';
        this.loading?.setAttribute('aria-hidden', 'true');
      }

      scrollToStart(behavior) {
        const header = document.querySelector('.shopify-section--header');
        const headerHeight = header?.getBoundingClientRect().height || 0;
        const top = this.getBoundingClientRect().top + window.scrollY - headerHeight - 12;

        window.scrollTo({
          top: Math.max(0, top),
          behavior
        });
      }

      isTrustedGoogleOrigin(origin) {
        try {
          const url = new URL(origin);
          const isGoogleHost =
            url.hostname === 'script.google.com' ||
            url.hostname.endsWith('.googleusercontent.com');

          return url.protocol === 'https:' && isGoogleHost;
        } catch (error) {
          return false;
        }
      }
    }

    customElements.define('quote-workspace-form', QuoteWorkspaceForm);
  }

  } catch(e) { console.error(e); }
})();
})();
